//React
import React, { lazy, Suspense } from 'react'
//Material-UI
import { Grow, Paper, IconButton, Box } from "@material-ui/core";
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import CloseIcon from '@material-ui/icons/Close';
import RemoveIcon from '@material-ui/icons/Remove';
//Componentes

//Hooks
import { useLocalization } from "contexto/localization/useLocalization";

const ChatWidget = lazy(() => import("./components/ChatWidget"));

const NAVBAR_HEIGHT = 70;
const CHAT_WIDTH = 400;
const CHAT_HEIGHT = 640;

const ChatPopper = () => {
    // Idioma
    const { strings } = useLocalization();
    // Estados
    const [open, setOpen] = React.useState(false);
    const [minimized, setMinimized] = React.useState(false);
    const [hasOpened, setHasOpened] = React.useState(false);
    const [shouldRenderChat, setShouldRenderChat] = React.useState(false);

    const anchorRef = React.useRef(null);
    const [pos, setPos] = React.useState({ x: 0, y: 0 });
    const dragging = React.useRef(false);
    const dragStart = React.useRef({ x: 0, y: 0 });


    React.useEffect(() => {
        const padding = 5;
        const winW = window.innerWidth;

        const boxW = CHAT_WIDTH;

        const initialX = winW - boxW - padding;
        const initialY = NAVBAR_HEIGHT + padding;

        setPos({ x: initialX, y: initialY });
    }, []);

    React.useEffect(() => {
        if (!open || !hasOpened) return;

        const timeoutId = window.setTimeout(() => {
            setShouldRenderChat(true);
        }, 0);

        return () => window.clearTimeout(timeoutId);
    }, [open, hasOpened]);

    const clampPosition = (x, y) => {
        const padding = 10;
        const winW = window.innerWidth;
        const winH = window.innerHeight;

        const boxW = CHAT_WIDTH;
        const boxH = Math.min(CHAT_HEIGHT, winH - NAVBAR_HEIGHT - padding * 2);

        const minX = padding;
        const maxX = winW - boxW - padding;

        const minY = NAVBAR_HEIGHT + padding;
        const maxY = winH - boxH - padding;

        return {
            x: Math.min(Math.max(x, minX), maxX),
            y: Math.min(Math.max(y, minY), maxY)
        };
    };

    // drag handlers
    const onMouseDown = (e) => {
        dragging.current = true;
        dragStart.current = {
            x: e.clientX - pos.x,
            y: e.clientY - pos.y
        };
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
    };



    const onMouseMove = React.useCallback((e) => {
        if (!dragging.current) return;
        const newX = e.clientX - dragStart.current.x;
        const newY = e.clientY - dragStart.current.y;
        setPos(clampPosition(newX, newY));
    }, []);

    const onMouseUp = React.useCallback(() => {
        dragging.current = false;
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
    }, [onMouseMove]);


    const handleToggle = () => {
        if (!hasOpened) setHasOpened(true);
        setMinimized(false);
        setOpen(prev => !prev);
    };

    const handleClose = () => {
        setOpen(false);
        setMinimized(false);
    };

    const handleMinimize = () => {
        setOpen(false);
        setMinimized(true);
    };

    const handleRestore = () => {
        if (!hasOpened) setHasOpened(true);
        setMinimized(false);
        setOpen(true);
    };

    return (
        <>
            {minimized && (
                <IconButton
                    onClick={handleRestore}
                    style={{
                        position: "fixed",
                        bottom: 20,
                        right: 20,
                        zIndex: 20000,
                        background: "#1976d2",
                        color: "white",
                        boxShadow: "0px 3px 6px rgba(0,0,0,0.3)"
                    }}
                >
                    <LiveHelpIcon />
                </IconButton>
            )}

            {!minimized && (
                <IconButton
                    ref={anchorRef}
                    onClick={handleToggle}
                >
                    <LiveHelpIcon htmlColor="white" />
                </IconButton>
            )}

            <Grow in={open && !minimized}>
                <div
                    style={{
                        position: "fixed",
                        top: pos.y,
                        left: pos.x,
                        zIndex: 15000
                    }}
                >
                    <Paper
                        elevation={5}
                        style={{
                            width: CHAT_WIDTH,
                            maxWidth: "95vw",
                            height: CHAT_HEIGHT,
                            maxHeight: `calc(100vh - ${NAVBAR_HEIGHT + 40}px)`,
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            userSelect: "none"
                        }}
                    >
                        <Box
                            onMouseDown={onMouseDown}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            padding="4px 10px"
                            style={{
                                cursor: "move",
                                background: "#f0f0f0",
                                borderBottom: "1px solid #dcdcdc",
                                height: 40
                            }}
                        >
                            <Box fontWeight="bold">{strings.modules.asistente} AustranetGRC</Box>

                            <Box>
                                <IconButton size="small" onClick={handleMinimize}>
                                    <RemoveIcon fontSize="small" />
                                </IconButton>
                                <IconButton size="small" onClick={handleClose}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        </Box>

                        <Box style={{ flex: 1, overflow: "auto" }}>
                            {shouldRenderChat && (
                                <Suspense fallback={<div>Cargando chat...</div>}>
                                  <ChatWidget provider='copilotStudio' />
                                </Suspense>
                            )}
                        </Box>
                    </Paper>
                </div>
            </Grow>
        </>
    )
}

export default ChatPopper
